
define('modules/application/wizard/classes/powerSupplyWithSirens',[

    "app",

    // Libs
    "backbone",

    //Classes
    "./genericElement",
    "./genericIncrementalElement",

    //Plugins
    "plugins/jquery-transit"
  ],

  function(app, Backbone, genericElement, genericIncrementalElement) {

    var powerSupplyWithSirens = _.extend({}, genericElement, {

      Views: {

        titleBar: genericElement.Views.titleBar.extend({
          template: "application/wizard/sections/powerSupplyWithSirens/titleBar",
          tagName: "h3",

          initialize: function() {
            this.model.unbind("updateViews", this.setLabel);
            this.model.bind("updateViews", this.setLabel, this);
            this.model.titleBarView = this;
            this.model.set('caption', '');
          },

          setLabel: function() {
            var captionToInsert,
              packageClassLabel,
              isPartOfKit,
              externalSirensLabel,
              internalSirensLabel,
              externalSirens,
              internalSirens,
              externalSirensValue = 0;

            if (this.model) {
              isPartOfKit = this.model.get("partOfKit");
              packageClassLabel = this.model.get("packageClassLabel");
              externalSirens = this.model.get("externalSirens");
              internalSirens = this.model.get("internalSirens");
              externalSirensValue = 0;


              if (!isPartOfKit) {
                captionToInsert = $.i18n._(packageClassLabel);
              } else {
                captionToInsert = $.i18n._(packageClassLabel) + " (KIT)";
              }

              if (externalSirens)
                for (var i = 0; i < externalSirens.length; i++)
                  externalSirensValue += externalSirens[i].value;

              if (((externalSirensValue > 0) || (internalSirens.value > 0)) && internalSirens.enabled) {
                captionToInsert += " - " + externalSirensValue + " " + $.i18n._("IDS_WAI2_403") + " - " + internalSirens.value + " " + $.i18n._("IDS_WAI2_407");
              }

              if ((packageClassLabel !== null) && (packageClassLabel !== "")) {
                this.model.titleBarView.$el.find(".titleBarcontent span").html(captionToInsert + " ");

                if (isPartOfKit)
                  this.model.titleBarView.$el.find(".titleBarcontent span").css("color", "#a0a2a3");

                this.model.titleBarView.$el.find(".titleBarcontent span").fadeIn(200);
              } else
                this.model.titleBarView.$el.find(".titleBarcontent span").fadeOut(200, function() {
                  $(this).hide();
                });
              this.model.set('caption', captionToInsert);
            }

          },

          removeLabel: function() {
            this.$el.find(".titleBarcontent span").fadeOut(200, function() {
              $(this).hide();
            });
          },

          enable: function() {
            this.$el.trigger("click");
          },

          disable: function() {
            this.$el.trigger("click");
          },

          onClose: function() {
            this.model.unbind("updateViews", this.setLabel);
          }
        }),

        content: genericElement.Views.content.extend({
          template: "application/wizard/sections/powerSupplyWithSirens/content",
          className: "powerSupplyWithSirens",

          events: {
            'change #powerSupply': 'powerSupplyChanged',
            'click .toggleInfoButton': 'toggleInfos',
            'click .toggleInfoSirensButton': 'toggleInfosSirens',
            'click .externalSirens#siren-0 .ui-spinner-up': 'incrementFirstExternalSirensValue',
            'click .externalSirens#siren-0 .ui-spinner-down': 'decrementFirstExternalSirensValue',
            'click .externalSirens#siren-1 .ui-spinner-up': 'incrementSecondExternalSirensValue',
            'click .externalSirens#siren-1 .ui-spinner-down': 'decrementSecondExternalSirensValue',
            'click .internalSirens .ui-spinner-up': 'incrementInternalSirensValue',
            'click .internalSirens .ui-spinner-down': 'decrementInternalSirensValue'
          },

          serialize: function() {
            return {
              model: this.model,
              app: app
            };
          },

          initialize: function() {
            this.model.set("view", this);

            BticinoS4B.eventAggregator.unbind('accessoryLine:chosen', this.setDetails);
            BticinoS4B.eventAggregator.bind('accessoryLine:chosen', this.setDetails, this);

            this.model.unbind("updateViews", this.setDetails);
            this.model.bind("updateViews", this.setDetails, this);
            this.model.unbind("updateSirens", this.updateSpinners);
            this.model.bind("updateSirens", this.updateSpinners, this);

            this.model.unbind("render:requested", this.render);
            this.model.bind("render:requested", this.render, this);

            if (window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"))
              this.model.accessoryLineChosenEventHandler(window.BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"));
          },

          toggleInfos: function(e) {
            return genericElement.Views.content.prototype.toggleInfos(e, this);
          },

          toggleInfosSirens: function(e) {
            return genericElement.Views.content.prototype.toggleInfos(e, this);
          },

          disableSection: function(force) {
            if (!this.model.get("enabled") || ((force !== undefined) && (force === true))) {
              this.$el.find("#powerSupply option").removeAttr("selected");
              this.$el.find("#powerSupply").attr("disabled", "disabled");
              this.$el.find("#powerSupply").removeAttr("rel");
              this.$el.find("span").remove();
              this.$el.find(".exampleImage").attr("src", "");
              this.$el.find(".description.powerSupply").html("");
              this.$el.find(".linkContainer").html("");
              window.customizeFormElements.call();
              this.hideDetails();
            }
          },

          enableSection: function() {
            if (this.model.get("enabled")) {
              this.$el.find("select#powerSupply").removeAttr("disabled");
              this.$el.find("span#selectpowerSupply").removeClass("disabled");
              this.showDetails();
            }
          },

          disableSirensSection: function() {
            if (!this.model.get("enabled")) {
              this.$el.find(".externalSirens").addClass("disabled");
              this.$el.find(".internalSirens").addClass("disabled");
            }
          },

          enableSirensSection: function() {
            if (this.model.get("enabled")) {
              this.$el.find(".externalSirens").removeClass("disabled");
              this.$el.find(".internalSirens").removeClass("disabled");
            }
          },

          showSirensDetails: function() {
            this.$el.find(".imageSirens").fadeIn(200);
            this.$el.find(".productCode").fadeIn(200);
            this.$el.find(".description").fadeIn(200);
            this.$el.find(".linkContainer").fadeTo(200, 1);
          },

          hideSirensDetails: function() {
            this.$el.find(".imageSirens").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".productCode").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".description").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".linkContainer").fadeTo(200, 0);
          },

          updateSpinners: function() {
            var externalSirensModel = _.extend({}, this.model.get("externalSirens"));
            var internalSirensModel = _.extend({}, this.model.get("internalSirens"));
            this.$el.find(".externalSirensSpinner .spinner").html(externalSirensModel[0].value);
            this.$el.find(".internalSirensSpinner .spinner").html(internalSirensModel.value);

            if (!externalSirensModel[0].enabled)
              this.$el.find(".externalSirensSpinner").addClass("disabled");
            else
              this.$el.find(".externalSirensSpinner").removeClass("disabled");

            if (!internalSirensModel.enabled)
              this.$el.find(".internalSirensSpinner").addClass("disabled");
            else
              this.$el.find(".internalSirensSpinner").removeClass("disabled");

            if ((!externalSirensModel.enabled) && (!internalSirensModel.enabled))
              this.hideDetails();
            else
              this.showDetails();
          },

          populateDropDown: function(pss) {
            var dropDownView = this.$el.find("select#powerSupply");
            dropDownView.children("option:first").attr("selected", "selected");
            dropDownView.children("option:not(:first)").remove();

            for (var i = 0; i < pss.length; i++)
              dropDownView.append("<option value=\"" + pss[i].packageClassId + "\">" + $.i18n._(pss[i].packageClassLabel) + "</option>");
          },

          powerSupplyChanged: function(event) {
            this.hideDetails();
            this.showLoader();
            var powerSupplyId = ($(event.target).val() === "") ? undefined : $(event.target).val();
            var powerSupplyLabel = ($(event.target).children("option:selected").text() === "") ? undefined : $(event.target).children("option:selected").text();
            this.model.set("name", powerSupplyLabel);
            this.model.set("id", powerSupplyId);
            this.model.set("packageClassId", powerSupplyId);
            window.BticinoS4B.solution.intrusionDetection.inserted = true;
          },

          //Retrieve and set the accessory line's details
          setDetails: function() {
            if ((this.model.get("productCode")) && (this.model.get("productCode") !== "")) {
              this.$el.find(".exampleImage.powerSupply").attr("src", "/images/" + (this.model.get("image") ? this.model.get("image") : "no-preview.jpg"));
              this.$el.find(".productCode.powerSupply").html(this.model.get("productCode"));

              if (this.model.get("packageClassDescription")) {
                if ($.i18n._(this.model.get("packageClassDescription")).length > 360) {
                  this.$el.find(".description.powerSupply").text($.i18n._(this.model.get("packageClassDescription")).substring(0, 360));
                  this.$el.find(".description.powerSupply").append("<br /><br /><span class='tooltip'>" + $.i18n._("IDS_W1_9032") + " ›</span>");
                  this.$el.find(".tooltip").qtip({
                    content: $.i18n._(this.model.get("packageClassDescription")),
                    show: 'click',
                    style: {
                      classes: 'ui-tooltip-shadow'
                    },
                    position: {
                      at: 'center left',
                      my: 'center right'
                    },
                    effect: function() {
                      $(this).fadeIn(200);
                    }
                  });
                } else
                  this.$el.find(".description.powerSupply").text($.i18n._(this.model.get("packageClassDescription")));
              }

              this.$el.find(".linkContainer").html("");

              if (this.model.get("packageInDepth") !== null) {
                var urlLink = BticinoS4B.Instances.Models.ApplicationModel.composeProductUrl(this.model.get("productCode"));
                this.$el.find(".linkContainer").append('<li class="packageInDepth"><a data-bypass href="' + urlLink + '" target="_blank"><div class="button"><img src="/assets/img/indepth-icon.png" class="icon indepth"/><span class="text">' + $.i18n._("IDS_W1_9015") + '</span></div></a></li>');
              }

              if (this.model.get("links")) {
                for (var i = 0; i < this.model.get("links").papers.length; i++) {
                  var paperToAppend = this.model.get("links").papers[i];
                  this.$el.find(".linkContainer").append('<li class="paper"><a data-bypass target="_blank" href="' + paperToAppend.link + '"><div class="button"><img src="/assets/img/paper-icon.png" class="icon paper"/><span class="text">' + $.i18n._(paperToAppend.label) + '</span></div></a></li>');
                  break;
                }

                for (var j = 0; j < this.model.get("links").images.length; j++) {
                  var imageToAppend = this.model.get("links").images[j];
                  this.$el.find(".linkContainer").append('<li class="image"><a data-bypass target="_blank" href="' + imageToAppend.link + '"><div class="button"><img src="/assets/img/image-icon.png" class="icon image"/><span class="text">' + $.i18n._(imageToAppend.label) + '</span></div></a></li>');
                  break;
                }

                for (var k = 0; k < this.model.get("links").videos.length; k++) {
                  var videoToAppend = this.model.get("links").videos[k];
                  this.$el.find(".linkContainer").append('<li class="video"><a data-bypass target="_blank" href="' + videoToAppend.link + '"><div class="button"><img src="/assets/img/video-icon.png" class="icon video"/><span class="text">' + $.i18n._(videoToAppend.label) + '</span></div></a></li>');
                  break;
                }
              }
              this.hideLoader(this.showDetails);
            } else
              this.hideLoader(this.hideDetails);

            this.enableSection();
          },

          showDetails: function() {
            this.$el.find(".exampleImage.powerSupply").fadeIn(200);
            this.$el.find(".productCode.powerSupply").fadeIn(200);
            this.$el.find(".description.powerSupply").fadeIn(200);
            this.$el.find(".linkContainer").fadeTo(200, 1);
          },

          hideDetails: function() {
            this.$el.find(".exampleImage.powerSupply").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".productCode.powerSupply").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".description.powerSupply").fadeOut(200, function() {
              $(this).hide();
            });
            this.$el.find(".linkContainer").fadeTo(200, 0);
          },

          decrementFirstExternalSirensValue: function() {
            this.model.decrementExternalSirensValue(0);
          },

          decrementSecondExternalSirensValue: function() {
            this.model.decrementExternalSirensValue(1);
          },

          incrementFirstExternalSirensValue: function() {
            this.model.incrementExternalSirensValue(0);
          },

          incrementSecondExternalSirensValue: function() {
            this.model.incrementExternalSirensValue(1);
          },

          decrementInternalSirensValue: function() {
            if (this.model.get("enabled"))
              this.model.decrementInternalSirensValue();
          },

          incrementInternalSirensValue: function() {
            if (this.model.get("enabled"))
              this.model.incrementInternalSirensValue();
          },



          showLoader: function() {
            this.$el.find(".mini-loader").fadeIn(200);
          },

          hideLoader: function(callback) {
            var that = this;
            this.$el.find(".mini-loader").fadeOut(200, function() {
              $(this).hide();
              if (callback)
                callback.call(that);
            });
          },

          isOpen: function() {
            return this.$el.css("display") == "block";
          },

          afterRender: function() {

            if ((this.model.get("packageClassId")) && (this.model.get("packageClassId") !== "")) {
              this.setDetails();
            }

            setTimeout(function() {
              window.customizeFormElements.call();
            }, 0);

          },

          onClose: function() {
            this.model.unbind("change #powerSupply");
          }
        })

      },

      Model: genericElement.Model.extend({
        defaults: {
          enabled: false,
          id: undefined,
          catalogId: undefined,
          image: undefined,
          links: {
            images: [],
            papers: [],
            videos: []
          },
          price: undefined,
          productCode: undefined,
          productDescription: undefined,
          productLabel: undefined,
          maxZoneNumber: undefined,
          externalSirens: [{
            enabled: false,
            value: 0,
            minValue: 0,
            maxValue: 2,
            packageClassId: ""
          }, {
            enabled: false,
            value: 0,
            minValue: 0,
            maxValue: 2,
            packageClassId: ""
          }],
          internalSirens: {
            enabled: false,
            value: 0,
            minValue: 0,
            maxValue: 3,
            packageClassId: "4203"
          }
        },

        initialize: function() {
          var that = this;

          //Bind on accessory line selection
          window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen', this.accessoryLineChosenEventHandler);
          window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen', this.accessoryLineChosenEventHandler, this);

          //Bind on accessory line removal
          window.BticinoS4B.eventAggregator.unbind('accessoryLine:removed', this.accessoryLineRemovedEventHandler);
          window.BticinoS4B.eventAggregator.bind('accessoryLine:removed', this.accessoryLineRemovedEventHandler, this);

          //Bind on materials overview model delivery request
          window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

          window.BticinoS4B.eventAggregator.unbind("load:Project", this.loadProject);
          window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

          window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.deliverCurrent);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);

          window.BticinoS4B.eventAggregator.unbind("powerSupply:addedFromKit", this.powerSupplyAddedFromKitEventHandler);
          window.BticinoS4B.eventAggregator.bind("powerSupply:addedFromKit", this.powerSupplyAddedFromKitEventHandler, this);
          window.BticinoS4B.eventAggregator.unbind("externalSirens:addedFromKit", this.sirensAddedFromKitEventHandler);
          window.BticinoS4B.eventAggregator.bind("externalSirens:addedFromKit", this.sirensAddedFromKitEventHandler, this);

          //Bind on power supply selection
          this.attributes.stepEventAggregator.unbind('powerSupply:chosen', this.powerSupplyChosenEventHandler);
          this.attributes.stepEventAggregator.bind('powerSupply:chosen', this.powerSupplyChosenEventHandler, this);

          //Bind on power supply removal
          this.attributes.stepEventAggregator.unbind('powerSupply:removed', this.powerSupplyRemovedEventHandler);
          this.attributes.stepEventAggregator.bind('powerSupply:removed', this.powerSupplyRemovedEventHandler, this);

          window.BticinoS4B.eventAggregator.unbind("removeKitItems", this.removeKitItems);
          window.BticinoS4B.eventAggregator.bind("removeKitItems", this.removeKitItems, this);

          this.unbind("change:id", this.idChanged);
          this.bind("change:id", this.idChanged);

          this.unbind("change:externalSirens", this.sirensModelChanged);
          this.bind("change:externalSirens", this.sirensModelChanged, this);
          this.unbind("change:internalSirens", this.sirensModelChanged);
          this.bind("change:internalSirens", this.sirensModelChanged, this);

        },

        accessoryLineChosenEventHandler: function(accessoryLineId) {
          this.fetchPSs(accessoryLineId);
          this.set("accessoryLineId", accessoryLineId);
          //this.disableSection();
          this.enableSection();
          var powerSupply = this.get("powerSupply");

          if (powerSupply)
            this.getSirensPackages(powerSupply);
        },

        incrementExternalSirensValue: function(sirenPosition) {
          var firstExternalSirensModel = this.get("externalSirens")[0],
            secondExternalSirensModel = this.get("externalSirens")[1],
            externalSirensModel = this.get("externalSirens")[sirenPosition],
            internalSirensModel = this.get("internalSirens"),
            maxSirens = this.get("maxSirens");

          if (externalSirensModel.enabled) {
            if ((externalSirensModel.value + 1) <= externalSirensModel.maxValue) {
              if ((firstExternalSirensModel.value + secondExternalSirensModel.value + internalSirensModel.value + 1) <= maxSirens)
                externalSirensModel.value = externalSirensModel.value + 1;

              this.trigger("updateViews");
              this.trigger("updateSirens");

              //Update currents consumption indicator
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            }
            return externalSirensModel.value;
          } else
            return null;
        },

        decrementExternalSirensValue: function(sirenPosition) {
          var externalSirensModel = this.get("externalSirens")[sirenPosition];

          if (externalSirensModel.enabled) {
            if ((externalSirensModel.value - 1) >= externalSirensModel.minValue) {
              externalSirensModel.value = externalSirensModel.value - 1;
              this.trigger("updateViews");
              this.trigger("updateSirens");

              //Update currents consumption indicator
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            }
            return this.get("interfaceValue");
          } else
            return null;
        },

        incrementInternalSirensValue: function() {
          var firstExternalSirensModel = this.get("externalSirens")[0],
            secondExternalSirensModel = this.get("externalSirens")[1],
            internalSirensModel = this.get("internalSirens"),
            maxSirens = this.get("maxSirens");

          if (internalSirensModel.enabled) {
            if ((internalSirensModel.value + 1) <= internalSirensModel.maxValue) {
              if ((firstExternalSirensModel.value + secondExternalSirensModel.value + internalSirensModel.value + 1) <= maxSirens)
                internalSirensModel.value = internalSirensModel.value + 1;

              this.set("internalSirens", internalSirensModel);
              this.trigger("updateViews");
              this.trigger("updateSirens");

              //Update currents consumption indicator
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            }
            return internalSirensModel.value;
          } else
            return null;
        },

        decrementInternalSirensValue: function() {
          var internalSirensModel = _.extend({}, this.get("internalSirens"));
          if (internalSirensModel.enabled) {
            if ((internalSirensModel.value - 1) >= internalSirensModel.minValue) {
              internalSirensModel.value = internalSirensModel.value - 1;
              this.set("internalSirens", internalSirensModel);
              this.trigger("updateViews");
              this.trigger("updateSirens");

              //Update currents consumption indicator
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            }
            return internalSirensModel.value;
          } else
            return null;
        },

        getSirensPackages: function() {
          var that = this,
            accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"),
            powerSupply = this,
            requiredExternalSirens = powerSupply.get("specialVars").externalSirens,
            requiredExternalSirensLength = 0,
            externalSirensModel = this.get("externalSirens"),
            internalSirensModel = this.get("internalSirens"),
            currentLoadedModel = this.get("loadedModel"),
            i = 0;

          if (requiredExternalSirens !== undefined)
            requiredExternalSirensLength = requiredExternalSirens.length;

          if (accessoryLineId !== undefined) {
            if (powerSupply.get("specialVars").maxSirens) {
              this.set("maxSirens", powerSupply.get("specialVars").maxSirens);
            }

            //Resetting values
            externalSirensModel[0].value = 0;
            externalSirensModel[1].value = 0;
            internalSirensModel.value = 0;

            var packagesRetrievedCallback = function(data) {
              data.specialVars = JSON.parse(data.specialVars);

              //Sorting elements by packageClassId
              that.fetchedSirens = data;

              var currentpackageClassid = "-1";

              if (currentpackageClassid !== that.fetchedSirens.packageClassId)
                currentpackageClassid = that.fetchedSirens.packageClassId;
              else {
                that.fetchedSirens.splice(i, 1);
                i--;
              }

              //_.extend(that.attributes, that.fetchedSirens[0]);
              _.extend(externalSirensModel[i], that.fetchedSirens);

              //Retrieving product details
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(externalSirensModel[i].packageClassId, productsRetrievedCallback);
            };

            var productsRetrievedCallback = function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var products = _.filter(data.products, function(product) {
                return ((product.mnemonic === 1));
              });

              if (products.length > 0)
                products = products[0];

              _.extend(externalSirensModel[i], products);
              externalSirensModel[i].enabled = true;

              var secondaryProducts;
              var secondaryProductsToPush = [];

              secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });

              externalSirensModel[i].secondaryProducts = secondaryProducts;
              externalSirensModel[i].enabled = true;
              externalSirensModel[i].value = powerSupply.get("specialVars").minExternalSirens;
              externalSirensModel[i].minValue = powerSupply.get("specialVars").minExternalSirens;
              externalSirensModel[i].maxValue = powerSupply.get("specialVars").maxExternalSirens;

            };

            //Assigning the correct siren's packageClassId based on the selected power supply
            for (i = 0; i < requiredExternalSirensLength; i++)
              externalSirensModel[i].packageClassId = requiredExternalSirens[i];

            //Retrieving external sirens
            for (i = 0; i < requiredExternalSirensLength; i++)
              if (externalSirensModel[i].packageClassId && externalSirensModel[i].packageClassId !== "")
                BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(externalSirensModel[i].packageClassId, packagesRetrievedCallback);

            for (i = requiredExternalSirensLength; i < externalSirensModel.length; i++)
              externalSirensModel[i].enabled = false;

            //Retrieving internal sirens
            BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(internalSirensModel.packageClassId, function(data) {
              //Sorting elements by packageClassId
              that.fetchedSirens = data;

              var currentpackageClassid = "-1";

              if (currentpackageClassid !== that.fetchedSirens.packageClassId)
                currentpackageClassid = that.fetchedSirens.packageClassId;
              else {
                that.fetchedSirens.splice(i, 1);
                i--;
              }

              _.extend(internalSirensModel, that.fetchedSirens);

              //Retrieving product details
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(internalSirensModel.packageClassId, function(data) {
                data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
                data.products = _.filter(data.products, function(product) {
                  return product.mnemonic == 1;
                });
                if (data.products.length > 0)
                  data = data.products[0];
                _.extend(internalSirensModel, data);
                internalSirensModel.enabled = true;

                var secondaryProducts = _.filter(data.products, function(product) {
                  return (product.mnemonic !== 1);
                });

                internalSirensModel.secondaryProducts = secondaryProducts;
              });
            });

            /*If there's a loading process load the correct values*/
            if (currentLoadedModel) {
              externalSirensModel[0].value = currentLoadedModel.externalSirens[0].value;
              externalSirensModel[0].partOfKit = currentLoadedModel.externalSirens[0].partOfKit;
              externalSirensModel[0].kitValue = currentLoadedModel.externalSirens[0].kitValue;

              externalSirensModel[1].value = currentLoadedModel.externalSirens[1].value;
              externalSirensModel[1].partOfKit = currentLoadedModel.externalSirens[1].partOfKit;
              externalSirensModel[1].kitValue = currentLoadedModel.externalSirens[1].kitValue;

              internalSirensModel.value = currentLoadedModel.internalSirens.value;
            }

            this.set("externalSirens", externalSirensModel);
            this.set("internalSirens", internalSirensModel);

            this.set("loadedModel", undefined);

            this.enableSection();
            this.trigger("updateViews");
          }
        },

        powerSupplyChosenEventHandler: function(powerSupply) {
          var powerSupplyID = powerSupply.id;
          this.set("id",powerSupply.id);

          //this.set("powerSupply", powerSupply);
          //window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          this.getSirensPackages();
        },

        accessoryLineRemovedEventHandler: function(accessoryLineId) {
          this.set("accessoryLineId", "");
          this.removeValues();
          //this.disableSection();
        },

        powerSupplyAddedFromKitEventHandler: function(addedPowerSupply) {
          this.set("partOfKit", true);
          this.set("kitValue", 1);
          this.set("id", addedPowerSupply.packageClassId);
          window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen', this.accessoryLineChosenEventHandler);
          this.trigger("updateViews");
          this.trigger("render:requested");
        },

        sirensAddedFromKitEventHandler: function(addedExternalSirens) {
          var externalSirens = this.get("externalSirens");
          externalSirens[0].partOfKit = true;
          externalSirens[0].minValue = addedExternalSirens.quantity;
          externalSirens[0].kitValue = addedExternalSirens.quantity;

          if (externalSirens[0].value) {
            if (externalSirens[0].value <= externalSirens[0].minValue)
              externalSirens[0].value = addedExternalSirens.quantity;
          } else
            externalSirens[0].value = addedExternalSirens.quantity;

          externalSirens[0].packageClassId = addedExternalSirens.packageClassId;

          this.set("externalSirens", externalSirens);
          this.trigger("updateViews");
        },

        removeKitItems: function() {
          if (this.get("partOfKit")) {
            this.removeValues();
            this.trigger("updateViews");
            this.trigger("render:requested");
          }
        },

        deliverModel: function() {
          var that = this,
            dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            externalItems,
            powerSupplyDeliveredModel,
            sirensDeliveredModel,
            powerSupplyTMP = that.get('powerSupply'),
            externalSirensTMP = that.get('externalSirens'),
            internalSirensTMP = that.get('internalSirens'),
            //loadedModelTMP = that.get('loadedModel'),
            maxSirensTMP = that.get('maxSirens'),
            stepEventAggregatorTMP = that.get('stepEventAggregator'),
            i = 0;

          powerSupplyDeliveredModel = jQuery.extend({}, that);
          //powerSupplyDeliveredModel._events = undefined;
          BticinoS4B.solution.intrusionDetection.powerSupply = powerSupplyDeliveredModel; //powerSupplyDeliveredModel;
          BticinoS4B.Instances.Models.ApplicationModel.set("powerSupply", BticinoS4B.solution.intrusionDetection.powerSupply);
          sirensDeliveredModel = jQuery.extend({}, that);

          BticinoS4B.solution.intrusionDetection.sirens = sirensDeliveredModel;
          BticinoS4B.Instances.Models.ApplicationModel.set("sirens", BticinoS4B.solution.intrusionDetection.sirens);

          that.set("stepEventAggregator", stepEventAggregatorTMP);

          dataProvider.addItems("externalItems", {
            productCode: that.get("productCode"),
            productLabel: that.get("productLabel"),
            packageClassId: that.get("packageClassId"),
            packageClassLabel: that.get("packageClassLabel"),
            kitValue: that.get("kitValue"),
            partOfKit: that.get("partOfKit"),
            quantity: 1,
            price: that.get("price"),
            isArticleSystem: true
          });

          if (that.get("secondaryProducts")) {
            for (i = 0; i < that.get("secondaryProducts").length; i++) {
              dataProvider.addItems("externalItems", {
                productCode: that.get("secondaryProducts")[i].productCode,
                productLabel: that.get("secondaryProducts")[i].productLabel,
                packageClassId: that.get("secondaryProducts")[i].packageClassId,
                packageClassLabel: that.get("secondaryProducts")[i].packageClassLabel,
                kitValue: that.get("kitValue"),
                partOfKit: that.get("partOfKit"),
                quantity: 1,
                price: that.get("secondaryProducts")[i].price
              });
            }
          }

          var externalSirens = that.get("externalSirens"),
            internalSirens = that.get("internalSirens"),
            j = 0;



          externalItems = BticinoS4B.Instances.Models.ApplicationModel.get("externalItems");

          for (i = 0; i < externalSirens.length; i++) {
            if (externalSirens[i].enabled) {
              dataProvider.addItems("externalItems", {
                productCode: externalSirens[i].productCode,
                productLabel: externalSirens[i].productLabel,
                packageClassId: externalSirens[i].packageClassId,
                packageClassLabel: externalSirens[i].packageClassLabel,
                kitValue: externalSirens[i].kitValue,
                partOfKit: externalSirens[i].partOfKit,
                quantity: externalSirens[i].value,
                price: externalSirens[i].price,
                isExternalSiren: true
              });

              if ((externalSirens[i].secondaryProducts) && (externalSirens[i].secondaryProducts.length > 0)) {
                for (j = 0; j < externalSirens[i].secondaryProducts.length; j++) {
                  dataProvider.addItems("externalItems", {
                    productCode: externalSirens[i].secondaryProducts[j].productCode,
                    productLabel: externalSirens[i].secondaryProducts[j].productLabel,
                    packageClassId: externalSirens[i].secondaryProducts[j].packageClassId,
                    packageClassLabel: externalSirens[i].secondaryProducts[j].packageClassLabel,
                    kitValue: externalSirens[i].kitValue,
                    partOfKit: externalSirens[i].partOfKit,
                    quantity: externalSirens[i].value,
                    price: externalSirens[i].secondaryProducts[j].price,
                    isExternalSirenSecondaryProduct: true
                  });
                }
              }
            }
          }

          dataProvider.addItems("externalItems", {
            productCode: internalSirens.productCode,
            packageClassId: internalSirens.packageClassId,
            productLabel: internalSirens.productLabel,
            packageClassLabel: internalSirens.packageClassLabel,
            quantity: internalSirens.value,
            price: internalSirens.price,
            isInternalSiren: true
          });

          if ((internalSirens.secondaryProducts) && (internalSirens.secondaryProducts.length > 0)) {
            for (i = 0; i < internalSirens.secondaryProducts.length; i++) {
              dataProvider.addItems("externalItems", {
                productCode: internalSirens.secondaryProducts[i].productCode,
                packageClassId: internalSirens.secondaryProducts[i].packageClassId,
                productLabel: internalSirens.secondaryProducts[i].productLabel,
                packageClassLabel: internalSirens.secondaryProducts[i].packageClassLabel,
                quantity: internalSirens.value,
                price: internalSirens.secondaryProducts[i].price
              });
            }
          }
        },

        fetchPSs: function(accessoryLineId) {
          var that = this;
          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("400", function(data) {

            //Converting specialData from json to object
            for (var i = 0; i < data.packages.length; i++)
              data.packages[i].specialVars = JSON.parse(data.packages[i].specialVars);

            //Sorting elements by packageClassId
            that.fetchedPS = data.packages;

            if (that.get("view")) that.get("view").populateDropDown(that.fetchedPS);
          }, undefined, false);
        },

        getPackageDetails: function(packageClassId) {
          var that = this;
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

          if ((packageClassId) && (packageClassId !== null) && (packageClassId !== "")) {
            accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId");

            BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageClassId, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var products = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });

              if (products.length > 0)
                products = products[0];

              _.extend(that.attributes, products);

              if ((that.get("id")) && (that.get("id") !== null) && (that.get("id") !== "")) {

                that.get("stepEventAggregator").trigger("powerSupply:chosen", that);
                window.BticinoS4B.eventAggregator.trigger("powerSupply:chosen", that);
                that.trigger("updateViews");
                BticinoS4B.Instances.Models.ApplicationModel.set("powerSupplyId", that.get("id"));

              } else {

                this.get("stepEventAggregator").trigger("powerSupply:removed");
                window.BticinoS4B.eventAggregator.trigger("powerSupply:removed", that);
                that.trigger("updateViews");
                BticinoS4B.Instances.Models.ApplicationModel.set("powerSupplyId", null);

              }

              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });

              that.set("secondaryProducts", secondaryProducts);

              //Update currents consumption indicator
              //window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
            });
          } else {
            this.get("stepEventAggregator").trigger("powerSupply:removed");
            window.BticinoS4B.eventAggregator.trigger("powerSupply:removed");
            this.removeValues();
            that.trigger("updateViews");
            this.get("view").hideLoader();
          }
        },

        idChanged: function(e) {
          var that = this;
          var selectedPS = _.filter(this.fetchedPS, function(ps) {
            return ps.packageClassId == that.id;
          });

          if (selectedPS.length === 0)
            BticinoS4B.Instances.Models.ApplicationModel.getPackageByIdPackageClass(this.get("id"), function(data) {
              _.extend(that.attributes, data);
              that.getPackageDetails(that.get("id"));
              that.trigger("render:requested");
            });
          else {
            _.extend(that.attributes, selectedPS[0]);
            that.getPackageDetails(this.get("id"));
            that.trigger("render:requested");
          }
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },

        disableSection: function() {
          var that = this;

          if (this.get("enabled")) {
            this.set("enabled", false);
            this.get("view").disableSection();
            this.titleBarView.removeLabel();
            if (this.get("view").isOpen()) this.titleBarView.disable();
          }

          this.set("id", undefined);
          this.set("packageClassId", undefined);
        },

        enableSection: function() {
          var that = this;
          if (!this.get("enabled")) {
            this.set("enabled", true);
            this.get("view").enableSection();
          }
        },

        removeValues: function() {
          this.set("image", "");
          this.set("links", {
            images: [],
            papers: [],
            videos: []
          });
          this.set("mnemonic", "");
          this.set("name", "");
          this.set("optionalPackages", "");
          this.set("packageActuator", "");
          this.set("packageClassId", null);
          this.set("packageClassLabel", null);
          this.set("packageInDepth", "");
          this.set("packageLoad", "");
          this.set("price", "");
          this.set("productCode", "");
          this.set("productInDepth", "");
          this.set("productLabel", "");
          this.set("productDescription", "");
          this.set("wizardChoiceDescription", "");
          this.set("wizardChoiceLabel", "");
          this.set("packageClassDescription", "");
          this.set("packageClassId", "");
          this.set("packageClassLabel", "");
          this.set("partOfKit", false);
          this.set("id", "");
          this.set("packageClassId", "");
          this.get("stepEventAggregator").trigger("powerSupply:removed");
        },

        loadProject: function(model) {
          var powerSupply = model.powerSupply;
          if (powerSupply) {
            this.set("id", powerSupply.packageClassId);
            this.set("packageClassId", powerSupply.packageClassId);
            this.set("partOfKit", powerSupply.partOfKit);
            this.set("kitValue", powerSupply.kitValue);
          }

          var sirens = model.sirens;
          if (sirens) {
            for (var i = sirens.externalSirens.length - 1; i >= 0; i--)
              _.extend(this.attributes.externalSirens[i], sirens.externalSirens[i]);

            _.extend(this.attributes.internalSirens, sirens.internalSirens);
          }

          if (powerSupply || sirens) {
            this.trigger("render:requested");
            this.trigger("updateViews");
          }
        },

        onClose: function() {
          this.unbind("change:id");
        },

        deliverCurrent: function() {
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel"),
            currentConsumption = 0;

          if (this.get("specialVars")) {

            currentConsumption = this.get("specialVars").currentConsumption;

            if (currentConsumption < 0)
              consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
            else
              consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
          }

          var externalSirensModel = this.get("externalSirens"),
            internalSirensModel = this.get("internalSirens"),
            externalSirensCurrentConsumption = 0,
            i = 0;

          if (externalSirensModel) {
            for (i = 0; i < externalSirensModel.length; i++) {
              if (externalSirensModel[i].specialVars) {
                externalSirensCurrentConsumption = externalSirensModel[i].value * externalSirensModel[i].specialVars.currentConsumption;
                if (externalSirensCurrentConsumption < 0)
                  consumptionIndicatorModel.addSupplyCurrent(externalSirensCurrentConsumption);
                else
                  consumptionIndicatorModel.addCurrentConsumption(externalSirensCurrentConsumption);
              }
            }
          }

          if ((internalSirensModel) && (internalSirensModel.specialVars)) {
            var internalSirensCurrentConsumption = internalSirensModel.value * $.parseJSON(internalSirensModel.specialVars).currentConsumption;
            if (internalSirensCurrentConsumption < 0)
              consumptionIndicatorModel.addSupplyCurrent(internalSirensCurrentConsumption);
            else
              consumptionIndicatorModel.addCurrentConsumption(internalSirensCurrentConsumption);
          }

        }

      })

    });

    // Required, return the module for AMD compliance
    return powerSupplyWithSirens;

  });